import { SelectOption } from '../../../../services/select/interfaces/SelectOption';
import { timeFramesOptions } from './timeFramesOptions';
import { TimeFrame } from '../../enum/TimeFrame';

export const revenueGrowthTimeFrameOptions: SelectOption[] = timeFramesOptions.filter(option =>
  [TimeFrame.YTD, TimeFrame.LastFiscalYear, TimeFrame.UpcomingFiscalYear].includes(option.value as TimeFrame),
);
